import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { translate } from '@td/shared_utils';
import { useTemplates } from '../contexts/templates-context';
import { defaultTaskFormValues, fieldTypes } from '../constants';
import { mapCategoryToOption, mapChecklistItemToOption } from '../utils/form';

const DEFAULT_TASK_TYPE = defaultTaskFormValues[fieldTypes.TASK_TYPE];
const TEMPLATE_APPLY_CONFIRMATION = translate(null, 'care_team_tasks.templates', 'apply_confirmation');

const useTemplateSynchronization = () => {
  const {
    values: { [fieldTypes.TASK_TYPE]: taskType },
    initialValues: { [fieldTypes.TASK_TYPE]: initialTaskType },
    setFieldValue
  } = useFormikContext();
  const templates = useTemplates();

  useEffect(() => {
    // Run following logic only on create form
    if (taskType && initialTaskType === DEFAULT_TASK_TYPE) {
      const template = templates[taskType.value];

      if (template && window.confirm(TEMPLATE_APPLY_CONFIRMATION)) {
        setFieldValue(fieldTypes.CATEGORY, mapCategoryToOption(template.category));
        setFieldValue(fieldTypes.CHECKLIST, template.checklist.map(mapChecklistItemToOption));
      }
    }
  }, [taskType]);
};

export default useTemplateSynchronization;
